import * as Sentry from '@sentry/react';

function normalizeAttributes(
  attributes: Record<string, string | undefined>,
): Record<string, string> {
  return Object.entries(attributes).reduce<Record<string, string>>(
    (accumulator, [key, value]) => {
      if (value) {
        accumulator[key] = value;
      }

      return accumulator;
    },
    {},
  );
}

export function recordHttpClientMetric(input: {
  method: string;
  statusCode?: number;
  outcome: 'success' | 'error';
  durationMs: number;
  module?: string;
  feature?: string;
}): void {
  const attributes = normalizeAttributes({
    method: input.method,
    status_code: input.statusCode ? String(input.statusCode) : 'network_error',
    outcome: input.outcome,
    module: input.module,
    feature: input.feature,
  });

  Sentry.metrics.count('http.client.requests', 1, {
    attributes,
  });
  Sentry.metrics.distribution('http.client.duration', input.durationMs, {
    unit: 'millisecond',
    attributes,
  });
}

export function recordSocketPingMetric(
  channel: string,
  durationMs: number,
): void {
  Sentry.metrics.distribution('socket.ping.duration', durationMs, {
    unit: 'millisecond',
    attributes: {
      channel,
    },
  });
}

export function recordSocketConnectionMetric(
  channel: string,
  event: string,
): void {
  Sentry.metrics.count('socket.connection.events', 1, {
    attributes: {
      channel,
      event,
    },
  });
}
